import { SPEECH_RECOGNITION_MESSAGES } from '../constants/speech-recognition.ts';

export const mapTranscriptToRecognizedText = (transcript: string): string => {
  if (!transcript) {
    return SPEECH_RECOGNITION_MESSAGES.NO_RESPONSE;
  }

  return transcript;
};
